// extracted by css-extract-rspack-plugin
module.exports =  {"container":"Source15-r2nw__container","title":"Source15-brfp__title","code":"Source15-q8PE__code"};